/* Print / save-as-PDF view (DOM-free string building, unit-tested): a page
   holding the exported plan image, sized to the paper, that prints itself. */
const esc = (s: string) => s.replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]!));

export function printHtml(title: string, dataUrl: string, w: number, h: number, note = ''): string {
  const landscape = w > h;
  return `<!doctype html><html><head><meta charset="utf-8"><title>${esc(title)} — Playout</title>
<style>
  @page{margin:12mm; size:${landscape ? 'landscape' : 'portrait'}}
  html,body{margin:0;background:#fff;color:#1E2523;font:12px/1.4 "Avenir Next",system-ui,sans-serif}
  main{display:flex;flex-direction:column;align-items:center;gap:8px;padding:12px}
  img{max-width:100%;max-height:calc(100vh - 60px);object-fit:contain}
  .cap{display:flex;justify-content:space-between;width:100%;color:#78827E}
  @media print{main{padding:0}img{max-height:calc(100vh - 30px)}}
</style></head><body><main>
<img src="${dataUrl}" width="${w}" height="${h}" alt="${esc(title)} floor plan">
<div class="cap"><span>${esc(title)}${note ? ' · ' + esc(note) : ''}</span><span>playout.homes</span></div>
</main><script>addEventListener('load', () => setTimeout(() => print(), 50));</script></body></html>`;
}
